import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { applyBrandCssVariables, loadStoredBrandConfig } from "../config/brand.js";
import { useSeoMetadata } from "../hooks/useSeoMetadata.js";
import PageFooter from "../components/PageFooter.jsx";
import SiteHeader from "../components/SiteHeader.jsx";

export default function RootLayout() {
  useSeoMetadata();

  useEffect(() => {
    applyBrandCssVariables(loadStoredBrandConfig());
  }, []);

  return (
    <>
      <SiteHeader />
      <Outlet />
      <PageFooter />
    </>
  );
}
